import { ReactEventHandler } from 'react';
import logo512 from '../../../../../assets/icons/companies/logo512.png';

export const handleError: ReactEventHandler<HTMLElement> = (e) => {
  (e.target as HTMLImageElement).src = logo512;
};
